export default function WebDesktop() {
  return (
    <>
      <section className="antialiased text-slate-500 bg-gradient-to-bl from-black/90 via-black to-black/95 scroll-smooth min-h-screen">
        <div className="bg-graph-cogs-slate-100/[0.04] flex flex-col py-12">
          <div className="px-8 py-10 text-white mx-auto max-w-5xl w-full rounded-2xl border border-slate-700/60 shadow-2xl shadow-blue-600/10 backdrop-blur-sm bg-transparent">
            <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
              <div>
                <h1 className="text-4xl font-bold leading-tight">Shofiyullah Al Ghozaly</h1>
                <p className="text-lg text-blue-100 mt-1">DevOps Engineer · Web Developer</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 text-sm">
              <div className="flex items-center px-3 py-2 rounded-full bg-white/5 border border-white/10">
                <svg className="w-5 h-5 mr-2 text-blue-100" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                Daerah Istimewa Yogyakarta, Indonesia
              </div>
              <div className="flex items-center px-3 py-2 rounded-full bg-white/5 border border-white/10">
                <svg className="w-5 h-5 mr-2 text-blue-100" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z" clipRule="evenodd" />
                </svg>
                www.algzl.my.id
              </div>
              <div className="flex items-center px-3 py-2 rounded-full bg-white/5 border border-white/10">
                <svg className="w-5 h-5 mr-2 text-blue-100" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                </svg>
                algzl27@gmail.com
              </div>
            </div>

            <div className="flex flex-wrap gap-3 mt-6 text-sm">
              <a
                href="https://www.linkedin.com/in/algzl/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 rounded-full border border-blue-200/50 bg-blue-500/20 text-white hover:border-white hover:bg-blue-500/30 transition-colors"
              >
                Hubungi via LinkedIn
                <span className="ml-2 text-base">↗</span>
              </a>
              <a
                href="https://www.instagram.com/algzl27"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 rounded-full border border-white/30 bg-white/10 text-white hover:border-white hover:bg-white/20 transition-colors"
              >
                Ikuti di Instagram
              </a>
            </div>
          </div>

          <div className="px-8 py-8 max-w-5xl mx-auto w-full">
            {/* Profile Section */}
            <section className="mb-12">
              <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-xl p-6 backdrop-blur-sm hover:border-blue-500/30 transition-all duration-300">
                <div className="flex items-center mb-4">
                  <div className="w-1 h-8 bg-gradient-to-b from-blue-500 to-indigo-600 rounded-full mr-4"></div>
                  <h2 className="text-2xl font-bold text-white">Tentang</h2>
                </div>
                <p className="text-slate-300 leading-relaxed">
                  Halo! Saya Shofiyullah Al Ghozaly, biasa di panggil AL, seorang Programmer dengan latar belakang Sarjana Informatika. Sejak 2019 saya berkecimpung dalam pengembangan aplikasi web dengan Laravel dan React JS. Saat ini saya bekerja di salah satu universitas swasta di Yogyakarta, sambil terus memperdalam DevOps dan arsitektur Microservices untuk membangun sistem yang lebih scalable dan reliable.
                </p>
              </div>
            </section>

            {/* Experience Section */}
            <section className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-1 h-8 bg-gradient-to-b from-blue-500 to-indigo-600 rounded-full mr-4"></div>
                <h2 className="text-2xl font-bold text-white">Pengalaman Kerja</h2>
              </div>

              <div className="space-y-4">
                <div className="relative pl-8 pb-8 border-l-2 border-blue-500/30 hover:border-blue-500 transition-all duration-300">
                  <div className="absolute -left-4 top-0 w-6 h-6 bg-blue-500 rounded-full border-4 border-black/90"></div>
                  <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-5 backdrop-blur-sm hover:border-blue-500/30 transition-all duration-300">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h3 className="text-lg font-bold text-slate-100">Bidang Pengembangan & Operasi</h3>
                        <p className="text-sm font-semibold text-slate-200">Arsitek Perangkat Lunak</p>
                        <p className="text-blue-400 font-medium text-sm mt-1">Universitas Teknologi Yogyakarta</p>
                      </div>
                      <span className="text-xs text-slate-300 bg-blue-900/40 px-3 py-1 rounded-full border border-blue-700/40">Jan 2025 - Sekarang</span>
                    </div>
                    <p className="text-slate-400 text-sm mt-3">Saat ini · lebih dari 1 tahun</p>
                  </div>
                </div>

                <div className="relative pl-8 pb-8 border-l-2 border-blue-500/30 hover:border-blue-500 transition-all duration-300">
                  <div className="absolute -left-4 top-0 w-6 h-6 bg-blue-500 rounded-full border-4 border-black/90"></div>
                  <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-5 backdrop-blur-sm hover:border-blue-500/30 transition-all duration-300">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h3 className="text-lg font-bold text-slate-100">Asisten Pengembangan Teknologi</h3>
                        <p className="text-blue-400 font-medium text-sm">Universitas Teknologi Yogyakarta</p>
                      </div>
                      <span className="text-xs text-slate-300 bg-blue-900/40 px-3 py-1 rounded-full border border-blue-700/40">Jan 2025 - Sekarang</span>
                    </div>
                    <p className="text-slate-400 text-sm mt-3">Saat ini · lebih dari 1 tahun</p>
                  </div>
                </div>

                <div className="relative pl-8 border-l-2 border-blue-500/30 hover:border-blue-500 transition-all duration-300">
                  <div className="absolute -left-4 top-0 w-6 h-6 bg-blue-500 rounded-full border-4 border-black/90"></div>
                  <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-5 backdrop-blur-sm hover:border-blue-500/30 transition-all duration-300">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h3 className="text-lg font-bold text-slate-100">Software Programmer</h3>
                        <p className="text-blue-400 font-medium text-sm">Universitas Teknologi Yogyakarta</p>
                      </div>
                      <span className="text-xs text-slate-300 bg-blue-900/40 px-3 py-1 rounded-full border border-blue-700/40">Nov 2019 - Sekarang</span>
                    </div>
                    <p className="text-slate-400 text-sm mt-3">Saat ini · 6 tahun 3 bulan</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Education Section */}
            <section className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-1 h-8 bg-gradient-to-b from-green-500 to-emerald-600 rounded-full mr-4"></div>
                <h2 className="text-2xl font-bold text-white">Pendidikan</h2>
              </div>

              <div className="space-y-4">
                <div className="relative pl-8 pb-4 border-l-2 border-green-500/30 hover:border-green-500 transition-all duration-300">
                  <div className="absolute -left-4 top-0 w-6 h-6 bg-green-500 rounded-full border-4 border-black/90"></div>
                  <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-5 backdrop-blur-sm hover:border-green-500/30 transition-all duration-300">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-bold text-slate-100">Gelar Sarjana</h3>
                        <p className="text-green-400 font-medium text-sm">Informatika</p>
                        <p className="text-slate-400 text-sm mt-1">Universitas Teknologi Yogyakarta</p>
                      </div>
                      <span className="text-xs text-slate-300 bg-green-900/40 px-3 py-1 rounded-full border border-green-700/40">2015 - 2019</span>
                    </div>
                  </div>
                </div>

                <div className="relative pl-8 border-l-2 border-green-500/30 hover:border-green-500 transition-all duration-300">
                  <div className="absolute -left-4 top-0 w-6 h-6 bg-green-500 rounded-full border-4 border-black/90"></div>
                  <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-5 backdrop-blur-sm hover:border-green-500/30 transition-all duration-300">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-bold text-slate-100">Sekolah Menengah Kejuruan</h3>
                        <p className="text-green-400 font-medium text-sm">Teknik Komputer Jaringan</p>
                        <p className="text-slate-400 text-sm mt-1">SMK Swasta di Jawa Timur</p>
                      </div>
                      <span className="text-xs text-slate-300 bg-green-900/40 px-3 py-1 rounded-full border border-green-700/40">2012 - 2015</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Skills Section */}
            <section className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-1 h-8 bg-gradient-to-b from-purple-500 to-pink-600 rounded-full mr-4"></div>
                <h2 className="text-2xl font-bold text-white">Keahlian</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-blue-500/30 transition-all duration-300">
                  <h3 className="font-bold text-slate-100 mb-4 flex items-center">
                    <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                    Development
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-blue-900/50 text-blue-300 px-3 py-1 rounded-full text-sm border border-blue-700/50 hover:border-blue-500 transition-all">Laravel</span>
                    <span className="bg-blue-900/50 text-blue-300 px-3 py-1 rounded-full text-sm border border-blue-700/50 hover:border-blue-500 transition-all">React JS</span>
                    <span className="bg-blue-900/50 text-blue-300 px-3 py-1 rounded-full text-sm border border-blue-700/50 hover:border-blue-500 transition-all">API Gateways</span>
                    <span className="bg-blue-900/50 text-blue-300 px-3 py-1 rounded-full text-sm border border-blue-700/50 hover:border-blue-500 transition-all">GPS Tracking</span>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-green-500/30 transition-all duration-300">
                  <h3 className="font-bold text-slate-100 mb-4 flex items-center">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                    DevOps & Infrastructure
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-green-900/50 text-green-300 px-3 py-1 rounded-full text-sm border border-green-700/50 hover:border-green-500 transition-all">K3s</span>
                    <span className="bg-green-900/50 text-green-300 px-3 py-1 rounded-full text-sm border border-green-700/50 hover:border-green-500 transition-all">Docker</span>
                    <span className="bg-green-900/50 text-green-300 px-3 py-1 rounded-full text-sm border border-green-700/50 hover:border-green-500 transition-all">CI/CD Jenkins</span>
                    <span className="bg-green-900/50 text-green-300 px-3 py-1 rounded-full text-sm border border-green-700/50 hover:border-green-500 transition-all">Proxmox</span>
                    <span className="bg-green-900/50 text-green-300 px-3 py-1 rounded-full text-sm border border-green-700/50 hover:border-green-500 transition-all">DNS Server</span>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-purple-500/30 transition-all duration-300">
                  <h3 className="font-bold text-slate-100 mb-4 flex items-center">
                    <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                    Architecture & Security
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-purple-900/50 text-purple-300 px-3 py-1 rounded-full text-sm border border-purple-700/50 hover:border-purple-500 transition-all">Microservices</span>
                    <span className="bg-purple-900/50 text-purple-300 px-3 py-1 rounded-full text-sm border border-purple-700/50 hover:border-purple-500 transition-all">Security Ops</span>
                    <span className="bg-purple-900/50 text-purple-300 px-3 py-1 rounded-full text-sm border border-purple-700/50 hover:border-purple-500 transition-all">Reverse Proxy</span>
                    <span className="bg-purple-900/50 text-purple-300 px-3 py-1 rounded-full text-sm border border-purple-700/50 hover:border-purple-500 transition-all">Safeline WAF</span>
                  </div>
                </div>
              </div>
            </section>

            {/* Projects Section */}
            <section className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-1 h-8 bg-gradient-to-b from-cyan-500 to-blue-600 rounded-full mr-4"></div>
                <h2 className="text-2xl font-bold text-white">Proyek</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="group bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-cyan-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg font-bold text-slate-100 flex-1">Rmoda Rent A Car</h3>
                    <span className="text-xs text-slate-300 bg-cyan-900/40 px-3 py-1 rounded-full border border-cyan-700/40 whitespace-nowrap ml-2">Nov 2025 - Sekarang</span>
                  </div>
                  <p className="text-slate-300 mb-4 text-sm leading-relaxed">
                    Aplikasi Internal Untuk Mengelolah Penyewaan Mobil dengan sistem tracking real-time
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">Laravel</span>
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">GPS Tracking</span>
                  </div>
                </div>

                <div className="group bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-cyan-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg font-bold text-slate-100 flex-1">JDIH Bulungan</h3>
                    <span className="text-xs text-slate-300 bg-cyan-900/40 px-3 py-1 rounded-full border border-cyan-700/40 whitespace-nowrap ml-2">Apr 2021 - Sekarang</span>
                  </div>
                  <p className="text-slate-300 mb-4 text-sm leading-relaxed">
                    Jaringan Dokumentasi dan Informasi Hukum Pemerintah Kabupaten Bulungan untuk akses publik
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">Laravel</span>
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">Livewire</span>
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">Tailwindcss</span>
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">MySQL</span>
                  </div>
                </div>

                <div className="group bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-cyan-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg font-bold text-slate-100 flex-1">iRoom Service</h3>
                    <span className="text-xs text-slate-300 bg-cyan-900/40 px-3 py-1 rounded-full border border-cyan-700/40 whitespace-nowrap ml-2">Nov 2022 - Des 2024</span>
                  </div>
                  <p className="text-slate-300 mb-4 text-sm leading-relaxed">
                    Perusahaan jasa perbaikan produk-produk Apple yang profesional seperti service iPhone, iPad, iPod, iMac, Macbook dan Apple Watch
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">Laravel</span>
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">MySQL</span>
                  </div>
                </div>

                <div className="group bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-cyan-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg font-bold text-slate-100 flex-1">One Click</h3>
                    <span className="text-xs text-slate-300 bg-cyan-900/40 px-3 py-1 rounded-full border border-cyan-700/40 whitespace-nowrap ml-2">Jan 2022 - Des 2023</span>
                  </div>
                  <p className="text-slate-300 mb-4 text-sm leading-relaxed">
                    Solusi one-click untuk meningkatkan produktivitas dan efisiensi workflow dengan antarmuka yang intuitif
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">Laravel</span>
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">MySQL</span>
                  </div>
                </div>

                <div className="group bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-cyan-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg font-bold text-slate-100 flex-1">Bumdes Negeri Soya</h3>
                    <span className="text-xs text-slate-300 bg-cyan-900/40 px-3 py-1 rounded-full border border-cyan-700/40 whitespace-nowrap ml-2">Des 2021 - Jan 2022</span>
                  </div>
                  <p className="text-slate-300 mb-4 text-sm leading-relaxed">
                    Platform manajemen bisnis desa untuk BUMDes Negeri Soya dengan fitur inventory dan laporan keuangan
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">Laravel</span>
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">MySQL</span>
                  </div>
                </div>


                <div className="group bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-cyan-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg font-bold text-slate-100 flex-1">PT. Tiga Bintang Terang</h3>
                    <span className="text-xs text-slate-300 bg-cyan-900/40 px-3 py-1 rounded-full border border-cyan-700/40 whitespace-nowrap ml-2">Mar 2020 - Agu 2020</span>
                  </div>
                  <p className="text-slate-300 mb-4 text-sm leading-relaxed">
                    Sistem design & fabrication untuk Coal Crushing Plant, Barge Loading Plant, dan Coal Washing Plant
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">CodeIgniter</span>
                    <span className="text-xs bg-cyan-900/40 text-cyan-300 px-2 py-1 rounded border border-cyan-700/40">MySQL</span>
                  </div>
                </div>
              </div>
            </section>

            {/* Certifications */}
            <section className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-1 h-8 bg-gradient-to-b from-amber-500 to-orange-600 rounded-full mr-4"></div>
                <h2 className="text-2xl font-bold text-white">Lisensi & Sertifikasi</h2>
              </div>
              <div className="space-y-4">
                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-amber-500/30 transition-all duration-300">
                  <div className="flex items-start">
                    <div className="w-12 h-12 rounded-lg bg-amber-900/40 border border-amber-700/40 flex items-center justify-center flex-shrink-0 mr-4">
                      <svg className="w-6 h-6 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 3.062v6.072A3.066 3.066 0 0117.853 17a306.556 306.556 0 00-7.853 1-7.853-1 3.066 3.066 0 01-2.812-3.062v-6.072a3.066 3.066 0 012.812-3.062z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <p className="font-bold text-slate-100">Microsoft Certified Azure Fundamentals</p>
                      <p className="text-sm text-slate-400 mt-1">Microsoft · Diterbitkan Jan 2025</p>
                      <p className="text-xs text-amber-400 mt-2">ID Kredensial: mAUC-Dw8X</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-amber-500/30 transition-all duration-300">
                  <div className="flex items-start">
                    <div className="w-12 h-12 rounded-lg bg-amber-900/40 border border-amber-700/40 flex items-center justify-center flex-shrink-0 mr-4">
                      <svg className="w-6 h-6 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 3.062v6.072A3.066 3.066 0 0117.853 17a306.556 306.556 0 00-7.853 1-7.853-1 3.066 3.066 0 01-2.812-3.062v-6.072a3.066 3.066 0 012.812-3.062z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <p className="font-bold text-slate-100">Microsoft Certified Security, Compliance, and Identity Fundamentals</p>
                      <p className="text-sm text-slate-400 mt-1">Microsoft · Diterbitkan Jan 2025</p>
                      <p className="text-xs text-amber-400 mt-2">ID Kredensial: wASFV-2FmN</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Publications & Patents */}
            <section className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-1 h-8 bg-gradient-to-b from-emerald-500 to-teal-600 rounded-full mr-4"></div>
                <h2 className="text-2xl font-bold text-white">Publikasi & Paten</h2>
              </div>
              <div className="space-y-4">
                <div className="bg-gradient-to-br from-emerald-900/30 to-slate-900/50 border border-emerald-700/30 rounded-lg p-6 backdrop-blur-sm hover:border-emerald-500/50 transition-all duration-300">
                  <div className="flex items-start mb-2">
                    <svg className="w-5 h-5 text-emerald-400 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 4a2 2 0 012-2h6a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V4z"></path>
                    </svg>
                    <div>
                      <h3 className="text-base font-bold text-slate-100">IMPLEMENTASI REST API PADA PUSAT INFORMASI MAHASISWA UNIVERSITAS TEKNOLOGI YOGYAKARTA</h3>
                      <p className="text-sm text-emerald-400 mt-2">📄 Publikasi · Universitas Teknologi Yogyakarta</p>
                      <p className="text-xs text-slate-400 mt-1">22 Nov 2019</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-br from-teal-900/30 to-slate-900/50 border border-teal-700/30 rounded-lg p-6 backdrop-blur-sm hover:border-teal-500/50 transition-all duration-300">
                  <div className="flex items-start mb-2">
                    <svg className="w-5 h-5 text-teal-400 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M13 7H7v6h6V7z"></path>
                    </svg>
                    <div>
                      <h3 className="text-base font-bold text-slate-100">IMPLEMENTASI REST API PADA PUSAT INFORMASI MAHASISWA UNIVERSITAS TEKNOLOGI YOGYAKARTA</h3>
                      <p className="text-sm text-teal-400 mt-2">🔐 Paten · EC00201984170</p>
                      <p className="text-xs text-slate-400 mt-1">Dikeluarkan 22 Nov 2019</p>
                      <p className="text-sm text-slate-300 mt-3">Program ini menerima masukan email dan kata sandi data pengguna PUSKOM sebagai administrator, Bagian Operasional (BO) sebagai pengunggah informasi dan MAHASISWA sebagai penerima informasi.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Languages */}
            <section className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-1 h-8 bg-gradient-to-b from-rose-500 to-red-600 rounded-full mr-4"></div>
                <h2 className="text-2xl font-bold text-white">Bahasa</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-rose-500/30 transition-all duration-300">
                  <div className="flex items-center justify-between mb-4">
                    <p className="font-bold text-slate-100">Bahasa Indonesia</p>
                    <span className="text-sm bg-rose-900/40 text-rose-300 px-3 py-1 rounded-full border border-rose-700/40">Professional</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2">
                    <div className="bg-gradient-to-r from-rose-500 to-rose-600 h-2 rounded-full" style={{ width: '100%' }}></div>
                  </div>
                </div>
                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-rose-500/30 transition-all duration-300">
                  <div className="flex items-center justify-between mb-4">
                    <p className="font-bold text-slate-100">Bahasa Jawa</p>
                    <span className="text-sm bg-rose-900/40 text-rose-300 px-3 py-1 rounded-full border border-rose-700/40">Menengah</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2">
                    <div className="bg-gradient-to-r from-rose-500 to-rose-600 h-2 rounded-full" style={{ width: '75%' }}></div>
                  </div>
                </div>
                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-rose-500/30 transition-all duration-300">
                  <div className="flex items-center justify-between mb-4">
                    <p className="font-bold text-slate-100">Bahasa Madura</p>
                    <span className="text-sm bg-rose-900/40 text-rose-300 px-3 py-1 rounded-full border border-rose-700/40">Menengah</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2">
                    <div className="bg-gradient-to-r from-rose-500 to-rose-600 h-2 rounded-full" style={{ width: '85%' }}></div>
                  </div>
                </div>
                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700/50 rounded-lg p-6 backdrop-blur-sm hover:border-rose-500/30 transition-all duration-300">
                  <div className="flex items-center justify-between mb-4">
                    <p className="font-bold text-slate-100">Bahasa Inggris</p>
                    <span className="text-sm bg-rose-900/40 text-rose-300 px-3 py-1 rounded-full border border-rose-700/40">Pemula</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2">
                    <div className="bg-gradient-to-r from-rose-500 to-rose-600 h-2 rounded-full" style={{ width: '25%' }}></div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </>
  )
}
